import React, { useState } from 'react';
import { useSchema } from '../../../contexts/SchemaContext';
import { ActionChip } from '../Selectors/ActionSelector';
import { LogicalOperatorSelector } from '../Selectors/OperatorSelector';
import ConditionCard from './ConditionCard';

// SVG Icons
const DeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

const ChevronUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
  </svg>
);

const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
  </svg>
);

const IndicatorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
  </svg>
);

const TrendLineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
  </svg>
);

const MoreIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
  </svg>
);

const DuplicateIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
  </svg>
);

const CompareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
  </svg>
);

const LibraryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>
);

const CandlestickIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 10V4a2 2 0 00-2-2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V10h-4zM6 10h4v4H6v-4z" />
  </svg>
);

/**
 * RuleGroupCard - Displays a rule group with its conditions
 * 
 * @param {Object} props
 * @param {Object} props.ruleGroup - Rule group data
 * @param {number} props.index - Group index
 * @param {Function} props.onUpdate - Update handler (index, updatedGroup) => void
 * @param {Function} props.onDelete - Delete handler (index) => void
 * @param {Function} props.onDuplicate - Duplicate handler (index) => void
 * @param {Function} props.onAddCondition - Add condition handler (groupIndex, conditionType) => void
 * @param {Function} props.onEditCondition - Edit condition handler (groupIndex, conditionIndex) => void
 * @param {Function} props.onDeleteCondition - Delete condition handler (groupIndex, conditionIndex) => void
 * @param {boolean} props.expanded - Whether card is expanded
 * @param {Function} props.onToggleExpand - Toggle expand handler
 * @param {boolean} props.editable - Whether group is editable
 */
const RuleGroupCard = ({
  ruleGroup,
  index,
  onUpdate,
  onDelete,
  onDuplicate,
  onAddCondition,
  onEditCondition,
  onDeleteCondition,
  expanded = true,
  onToggleExpand,
  editable = true,
  rulesSchema = null,
}) => {
  const { advancedRulesInfo } = useSchema();
  const [editingName, setEditingName] = useState(false);
  const [nameValue, setNameValue] = useState(ruleGroup?.groupName || '');
  const [anchorEl, setAnchorEl] = useState(null);
  const [addMenuAnchor, setAddMenuAnchor] = useState(null);

  if (!ruleGroup) return null;

  const { groupId, groupName, operator, action, conditions = [] } = ruleGroup;

  // Handle name edit
  const handleNameSave = () => {
    onUpdate(index, { ...ruleGroup, groupName: nameValue });
    setEditingName(false);
  };

  // Handle operator change
  const handleOperatorChange = (newOperator) => {
    onUpdate(index, { ...ruleGroup, operator: newOperator });
  };

  // Get border color based on action
  const getBorderClass = () => {
    switch (action) {
      case 'BUY': return 'border-l-success';
      case 'SELL': return 'border-l-error';
      default: return 'border-l-base-300';
    }
  };

  return (
    <div className={`card card-border bg-base-100 mb-4 border-l-4 ${getBorderClass()}`}>
      {/* Header */}
      <div
        className={`flex items-center px-4 py-3 bg-base-200 ${onToggleExpand ? 'cursor-pointer' : ''}`}
        onClick={onToggleExpand}
      >
        {/* Expand/Collapse */}
        {onToggleExpand && (
          <button className="btn btn-ghost btn-xs btn-circle mr-2">
            {expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </button>
        )}

        {/* Group Name */}
        <div className="flex-1 min-w-0">
          {editingName ? (
            <input
              type="text"
              className="input input input-sm w-48"
              value={nameValue}
              onChange={(e) => setNameValue(e.target.value)}
              onBlur={handleNameSave}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleNameSave();
                if (e.key === 'Escape') setEditingName(false);
              }}
              onClick={(e) => e.stopPropagation()}
              autoFocus
            />
          ) : (
            <div className="flex items-center gap-2">
              <span className="font-medium truncate">
                {groupName || `Rule Group ${index + 1}`}
              </span>
              {editable && (
                <button
                  className="btn btn-ghost btn-xs btn-circle"
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditingName(true);
                  }}
                >
                  <EditIcon />
                </button>
              )}
            </div>
          )}
          <p className="text-xs text-base-content/60">
            {conditions.length} condition{conditions.length !== 1 ? 's' : ''} • {operator}
          </p>
        </div>

        {/* Action Badge */}
        <ActionChip action={action} />

        {/* More Menu */}
        {editable && (
          <div className="dropdown dropdown-end ml-2">
            <div
              tabIndex={0}
              role="button"
              className="btn btn-ghost btn-xs btn-circle"
              onClick={(e) => e.stopPropagation()}
            >
              <MoreIcon />
            </div>
            <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-40">
              {onDuplicate && (
                <li>
                  <a onClick={() => onDuplicate(index)}>
                    <DuplicateIcon /> Duplicate
                  </a>
                </li>
              )}
              <li>
                <a className="text-error" onClick={() => onDelete(index)}>
                  <DeleteIcon /> Delete
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>

      {/* Content */}
      {expanded && (
        <>
          <div className="divider my-0"></div>
          <div className="card-body p-4">
            {/* Operator Selector */}
            {editable && (
              <div className="mb-4">
                <LogicalOperatorSelector
                  value={operator}
                  onChange={handleOperatorChange}
                  rulesSchema={rulesSchema}
                />
              </div>
            )}

            {/* Conditions List */}
            {conditions.length === 0 ? (
              <div className="py-6 text-center bg-base-200 rounded-lg border border-dashed border-base-300">
                <p className="text-base-content/60 mb-1">No conditions added yet</p>
                <p className="text-xs text-base-content/40">
                  Add indicator or trend line conditions below
                </p>
              </div>
            ) : (
              <div>
                {conditions.map((condition, condIndex) => (
                  <React.Fragment key={condIndex}>
                    <ConditionCard
                      condition={condition}
                      index={condIndex}
                      onDelete={editable ? () => onDeleteCondition(index, condIndex) : null}
                      onClick={editable ? () => onEditCondition(index, condIndex) : null}
                    />
                    {condIndex < conditions.length - 1 && (
                      <div className="text-center my-1">
                        <span className="badge badge-sm badge-ghost font-medium">
                          {operator}
                        </span>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>

          {/* Actions */}
          {editable && (
            <>
              <div className="divider my-0"></div>
              <div className="card-actions px-4 py-2">
                <div className="dropdown dropdown-top">
                  <div tabIndex={0} role="button" className="btn btn-sm btn-ghost gap-1">
                    <AddIcon /> Add Condition
                  </div>
                  <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-48">
                    <li>
                      <a onClick={() => onAddCondition(index, 'INDICATOR')}>
                        <IndicatorIcon /> Indicator Condition
                      </a>
                    </li>
                    {advancedRulesInfo?.compositeSupported && (
                      <li>
                        <a onClick={() => onAddCondition(index, 'COMPOSITE')}>
                          <CompareIcon /> Composite Condition
                        </a>
                      </li>
                    )}
                    <li>
                      <a onClick={() => onAddCondition(index, 'TRENDLINE')}>
                        <TrendLineIcon /> Trend Line Condition
                      </a>
                    </li>
                    {advancedRulesInfo?.candlestickSupported && (
                      <li>
                        <a onClick={() => onAddCondition(index, 'CANDLESTICK')}>
                          <CandlestickIcon /> Candlestick Pattern
                        </a>
                      </li>
                    )}
                    {advancedRulesInfo?.voteRuleSupported && (
                      <li>
                        <a onClick={() => onAddCondition(index, 'VOTE')}>
                          <IndicatorIcon /> Vote (N-of-M)
                        </a>
                      </li>
                    )}
                    {advancedRulesInfo?.chainRuleSupported && (
                      <li>
                        <a onClick={() => onAddCondition(index, 'CHAIN')}>
                          <TrendLineIcon /> Chain (Sequential)
                        </a>
                      </li>
                    )}
                    <div className="divider my-0"></div>
                    <li>
                      <a className="text-primary font-medium" onClick={() => onAddCondition(index, 'LIBRARY')}>
                        <LibraryIcon /> From Rule Library
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default RuleGroupCard;
